export default "__VITE_ASSET__CAsTTq1s__"